import { render, staticRenderFns } from "./ChallengesList.vue?vue&type=template&id=bbf31584&"
import script from "./ChallengesList.vue?vue&type=script&lang=js&"
export * from "./ChallengesList.vue?vue&type=script&lang=js&"
import style0 from "./ChallengesList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports